import React from 'react';
import { LinkedinIcon } from 'lucide-react';
const PHOTO = 'https://cdn.magicpatterns.com/uploads/uRFm4TqjemDmkSdPVLEX96/pasted-image.jpg';
const LINKEDIN_URL = 'https://www.linkedin.com/in/14vivin/';
export function HomePage() {
  return <div className="min-h-screen w-full bg-white text-slate-900 flex flex-col" data-id="element-2" data-mp="3poep743hjxmc">
      <main className="flex-grow flex items-center" data-id="element-3" data-mp="3krehypuwgotn">
        <div className="w-full max-w-xl mx-auto px-6 py-20 text-center" data-id="element-4" data-mp="2x0im9hnbp9h4">
          <img src={PHOTO} alt="Portrait of Vivin Varghese" className="w-28 h-28 md:w-32 md:h-32 rounded-full object-cover mx-auto" data-id="element-5" data-mp="2wyejj315ugif" />

          <h1 className="mt-8 font-serif text-4xl md:text-5xl font-semibold tracking-tight" data-id="element-6" data-mp="36rvb00dtrjix">
            Vivin Varghese
          </h1>

          <p className="mt-6 text-lg leading-relaxed text-slate-700" data-id="element-7" data-mp="2ea16ednla8d6">
            Two-plus decades across internet exchanges, peering, data centers, and cloud.
            Now building the connectivity backbone for the next billion users and an AI
            research scholar passionate about model training and agent routers for the next
            generation of ASI systems.
          </p>

          <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="mt-10 inline-flex items-center justify-center gap-2.5 h-12 px-7 rounded-full bg-[#0A66C2] text-white font-medium hover:bg-[#004182] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#0A66C2]" data-id="element-8" data-mp="2eo40sadyplvi">
            <LinkedinIcon className="w-5 h-5" data-id="element-9" data-mp="20qp36idk27sg" />
            Connect on LinkedIn
          </a>
          <p className="mt-3 text-sm text-slate-400" data-id="element-10" data-mp="20t1uvn947wip">linkedin.com/in/14vivin</p>
        </div>
      </main>

      <footer className="py-8 text-center text-sm text-slate-400" data-id="element-11" data-mp="3c5uluvu30gxp">
        © {new Date().getFullYear()} Vivin Varghese Meleadan
      </footer>
    </div>;
}